import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import { Card, CardContent, CardActions } from '@material-ui/core';
import Loading from '@base/Loading';
import { ButtonDefault, ButtonPrimary } from '@base/Button/Button';
import TextField from '@base/Inputs/Text/TextField';

import EscolaService from '@services/EscolaService';
import PaperCompararCartoesNomeDuplicado from './PaperCompararCartoesNomeDuplicado';

const StatusTratamentoGroup = ({ tratamento, onChangeStatus, onChangeOrigem, onInsertOutro, listagemOrigemProblema, onSubmit, onDescartar, loading, }) => {

  const [outraOrigemProblema, setOutraOrigemProblema] = useState(false);

  const handlerSalvar = (novoStatus, novaOrigem = '') => {

    if (novoStatus === 'RESOLVIDA' && novaOrigem === 'OUTRO' && !tratamento.outro.trim()) {
      setOutraOrigemProblema(true);
      onInsertOutro(true);
      return;
    }

    onChangeStatus(novoStatus);
    onChangeOrigem(novaOrigem);

    onSubmit(novoStatus, novaOrigem);
  };

  const handlerDescartar = () => {
    onDescartar('DESCARTADO');
  };


  const lista = listagemOrigemProblema || [];

  const semProblema = lista.find(opt =>
    opt.label.toLowerCase().includes('sem problema')
  );

  const comErro = lista.filter(opt =>
    !opt.label.toLowerCase().includes('sem problema')
  );

  return (
    <div style={{ marginBottom: 2 }}>

      <Grid item xs={12}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
          <ButtonDefault
            name="Pendente"
            style={{ backgroundColor: '#f50057', color: '#fff' }}
            onClick={() => handlerSalvar('PENDENTE')}
          />

          <ButtonDefault
            name="Tratando"
            style={{ backgroundColor: '#3f51b5', color: '#fff' }}
            onClick={() => handlerSalvar('EM_TRATAMENTO')}
          />

          {semProblema && (
            <ButtonDefault
              name={'Resolvido - ' + semProblema.label}
              style={{ backgroundColor: '#20752b', color: '#fff' }}
              onClick={() => handlerSalvar('RESOLVIDA', semProblema.value)}
            />
          )}
        </div>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {comErro.map(opt => {
            const isPreenchendoOutro = outraOrigemProblema && opt.value === 'OUTRO';
            return (
              <ButtonDefault
                key={opt.value}
                name={isPreenchendoOutro ? 'Salvar Outro Problema' : 'Resolvido - Erro ' + opt.label}
                style={{ backgroundColor: isPreenchendoOutro ? '#3f51b5' : '#d98507', color: '#fff' }}
                onClick={() => handlerSalvar('RESOLVIDA', opt.value)}
              />
            );
          })}

          <ButtonPrimary
            onClick={() => handlerDescartar()}
            name="Descartar Cartão"
            disabled={loading}
            style={{ backgroundColor: '#ad3a32', marginRight: "1rem" }}
          />

        </div>

      </Grid>
    </div >
  );
};

const WrapperCartaoTratamento = ({
  cartao,
  processo,
  blob,
  todosCartoes,
  listagemStatusCartao,
  listagemOrigemProblema,
  onUpdateCartoes,
  toastRef,
}) => {
  const isPendente = cartao.status === 'COM_PENDENCIA_NOME_DUPLICADO';

  const [status, setStatus] = useState(cartao.tratamentoNomeDuplicado?.status ?? '');
  const [origem, setOrigem] = useState(cartao.tratamentoNomeDuplicado?.origem ?? '');
  const [outro, setOutro] = useState(cartao.tratamentoNomeDuplicado?.descricaoOrigemOutro ?? '');
  const [nome, setNome] = useState(cartao.nomeAluno ?? '');
  const [loading, setLoading] = useState(false);
  const [insertOutro, setInsertOutro] = useState(false);

  const handlerSalvarTratamentoNomeDuplicado = (statusParam, origemParam) => {

    const statusFinal = statusParam ?? status;
    const origemFinal = origemParam ?? origem;

    if (statusFinal === 'RESOLVIDA' && origemFinal === 'OUTRO' && !outro.trim()) {
      toastRef.current.show('warning', 'Por favor, descreva qual foi o problema.');
      return;
    }

    setLoading(true);

    EscolaService.atualizarStatusTratamentoNomeDuplicado(processo, cartao.id, {
      status: statusFinal !== '' ? statusFinal : undefined,
      nomeSubstituto: nome,
      origemProblema: origemFinal !== '' ? origemFinal : undefined,
      descricaoOrigemOutro: outro !== '' ? outro : undefined,
    })
      .then(() => {
        toastRef.current.show('success', 'Nome tratado com sucesso.');
        onUpdateCartoes();
      })
      .catch(err => {
        const msgs = err?.response?.data?.mensagens?.join(', ') ?? 'Erro desconhecido.';
        toastRef.current.show('error', `Erro: ${msgs}`);
      })
      .finally(() => setLoading(false));
  };

  const handlerDescartar = () => {

    setLoading(true);

    let obj = {};
    obj.motivo = "TRATAMENTO_NOME_DUPLICADO";

    EscolaService.descartarCartao(processo, cartao.id, obj)
      .then(resultado => {
        toastRef.current.show("success", "Cartão descartado com sucesso.");
        onUpdateCartoes();
      })
      .catch(err => {
        const msgs = err?.response?.data?.mensagens?.join(', ') ?? 'Erro desconhecido.';
        toastRef.current.show('error', `Erro: ${msgs}`);
      })
      .finally(() => setLoading(false));

  }


  return (
    <Grid container style={{ padding: '8px 4px' }}>
      <Grid item xs={12}>
        <Card variant="outlined">

          {loading ? (
            <Loading />
          ) : (
            <>
              {isPendente && (
                <CardContent style={{ padding: '8px 16px' }}>
                  <TextField
                    label="Nome do Aluno"
                    value={nome}
                    onChange={e => setNome(e.target.value)}
                    fullWidth
                    disabled={true}
                    margin="dense"
                  />

                  <Grid container spacing={3}>
                    <Grid item xs={12} xl={6}>
                      <TextField
                        label="Status do Tratamento"
                        value={status}
                        onChange={e => setStatus(e.target.value)}
                        fullWidth
                        disabled={true}
                        margin="dense"
                      />
                    </Grid>

                    {origem && (
                      <Grid item xs={12} xl={6}>
                        <TextField
                          label="Origem do Problema"
                          value={origem}
                          onChange={e => setOrigem(e.target.value)}
                          fullWidth
                          disabled={true}
                          margin="dense"
                        />
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              )}

              <CardContent style={{ padding: '0 16px' }}>
                <PaperCompararCartoesNomeDuplicado
                  cartao={cartao}
                  processo={processo}
                  blob={blob}
                  cartoes={todosCartoes}
                  listagemStatus={listagemStatusCartao}
                  onCartoesUpdate={onUpdateCartoes}
                  isPodeUsarAcoes={isPendente}
                />
              </CardContent>

              <CardContent style={{ padding: '0 16px 8px 16px' }}>
                {(insertOutro || outro !== '') && (
                  <TextField
                    label="Qual foi o problema?"
                    value={outro}
                    onChange={e => setOutro(e.target.value)}
                    fullWidth
                    margin="dense"
                  />
                )}
              </CardContent>

              {isPendente && (
                <CardActions style={{ justifyContent: 'space-between', padding: '20px 16px' }}>
                  <StatusTratamentoGroup
                    onChangeStatus={setStatus}
                    onChangeOrigem={setOrigem}
                    onInsertOutro={setInsertOutro}
                    listagemOrigemProblema={listagemOrigemProblema}
                    onSubmit={handlerSalvarTratamentoNomeDuplicado}
                    onDescartar={handlerDescartar}
                    tratamento={{ status: status, origem: origem, outro: outro }}
                    loading={loading}
                  />
                </CardActions>
              )}
            </>
          )}
        </Card>
      </Grid>
    </Grid>
  );
};

export default WrapperCartaoTratamento;